import { render, staticRenderFns } from "./trainingDetailView.vue?vue&type=template&id=20cb1640"
import script from "./trainingDetailView.vue?vue&type=script&lang=js"
export * from "./trainingDetailView.vue?vue&type=script&lang=js"
import style0 from "./trainingDetailView.vue?vue&type=style&index=0&id=20cb1640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports